import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createEditorSlice } from '../../views/editor/stores/ui/editor-ui-slice';
import { EditorSlice } from '../../views/editor/stores/ui/editor-ui-slice.types';
import { createGlobalSlice } from './slices/global-ui-slice';
import { GlobalSlice } from './slices/global-ui-slice.types';

export type UIStore = EditorSlice & GlobalSlice;

export const useUIStore = create<UIStore>()(
  devtools(
    (...a) => ({
      ...createEditorSlice(...a),
      ...createGlobalSlice(...a),
    }),
    {
      name: 'UIStore',
      enabled: process.env.REACT_APP_ZUSTAND_DEVTOOLS === 'true',
      trace: true,
    },
  ),
);
